import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./components/Home";
import Terms from "./components/Modal/terms";
import Privacy from "./components/Modal/privacy";
import WorkplacePolicy from "./components/Modal/WorkplacePolicy";
import LanguageWrapper from "./components/LanguageWrapper";
import Features from "./components/pages/Features";
import FeaturePage from "./components/pages/FeaturePage";
import IndustryPage from "./components/pages/IndustryPage";
import ComparisonPage from "./components/pages/ComparisonPage";
import SolutionPage from "./components/pages/SolutionPage";
import PersonaPage from "./components/pages/PersonaPage";
import Pricing from "./components/pages/Pricing";
import About from "./components/pages/About";
import Contact from "./components/pages/Contact";
import BlogIndex from "./components/pages/BlogIndex";
import BlogPost from "./components/pages/BlogPost";

import "./App.css";

function App() {
  return (
    <HelmetProvider>
    <Router>
      <div className="App">
        <Routes>
          {/* Language-prefixed routes */}
          <Route path="/:lang" element={<LanguageWrapper />}>
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />
            <Route path="features" element={<Features />} />
            <Route path="features/:featureSlug" element={<FeaturePage />} />
            <Route path="industries/:industrySlug" element={<IndustryPage />} />
            <Route path="compare/:compareSlug" element={<ComparisonPage />} />
            <Route path="solutions/:solutionSlug" element={<SolutionPage />} />
            <Route path="for/:personaSlug" element={<PersonaPage />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="blog" element={<BlogIndex />} />
            <Route path="blog/:slug" element={<BlogPost />} />
            <Route path="privacy-policy" element={<Privacy />} />
            <Route path="terms-of-service" element={<Terms />} />
            <Route path="workplace-policy" element={<WorkplacePolicy />} />
          </Route>

          {/* Root routes without language prefix */}
          <Route path="/" element={<LanguageWrapper />}>
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />
            <Route path="features" element={<Features />} />
            <Route path="features/:featureSlug" element={<FeaturePage />} />
            <Route path="industries/:industrySlug" element={<IndustryPage />} />
            <Route path="compare/:compareSlug" element={<ComparisonPage />} />
            <Route path="solutions/:solutionSlug" element={<SolutionPage />} />
            <Route path="for/:personaSlug" element={<PersonaPage />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="blog" element={<BlogIndex />} />
            <Route path="blog/:slug" element={<BlogPost />} />
            <Route path="privacy-policy" element={<Privacy />} />
            <Route path="terms-of-service" element={<Terms />} />
            <Route path="workplace-policy" element={<WorkplacePolicy />} />
          </Route>
        </Routes>
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;
